import type React from 'react';

import type { Column, Table } from '@tanstack/react-table';
import DataTableSearchInput from './DataTableSearchInput';

import DataTableColumns from '../components/DataTableColumns';
import ExportComponent from '../components/Export';

interface SearchAndToolsProps<TData> {
  globalFilter: string;
  onChangeSearch: (value: string) => void;
  table: Table<TData>;
  columns: Column<TData>[];
  visibleColumns: Column<TData>[];
  customToolbar: React.ReactNode;
  exportDef: any;
  Export: any;
  data: TData[];
  placeholder?: string;
  search?: string | false;
  showColumnFilter?: boolean;
  showSearch?: boolean;
}

const DataTableSearchAndTools = <TData,>({
  data,
  onChangeSearch,
  table,
  columns,
  visibleColumns,
  customToolbar,
  exportDef,
  Export,
  placeholder = 'Pesquisar...',
  showSearch = false,
  search,
  showColumnFilter = true,
}: SearchAndToolsProps<TData>) => {
  return (
    <div className='grid grid-cols-12 items-center pb-5'>
      <div className='col-span-12 laptop:col-span-8 tablet:col-span-12 flex flex-wrap items-center gap-2.5'>
        {showSearch && <DataTableSearchInput value={search || ''} placeholder={placeholder} onChange={onChangeSearch} />}
        {customToolbar}
      </div>
      <div className='col-span-12 laptop:col-span-4 tablet:col-span-12 laptop:mt-0 mt-4 flex justify-start laptop:justify-end gap-2'>
        {showColumnFilter && <DataTableColumns columns={columns} visibleColumns={visibleColumns} />}
        <div>
          {exportDef && Export && data ? Export(table, data, exportDef) : null}
          {!exportDef && Export && data ? Export(table, data, exportDef) : null}
          {exportDef && !Export && data ? <ExportComponent data={data} table={table} exportDef={exportDef} /> : null}
        </div>
      </div>
    </div>
  );
};

export default DataTableSearchAndTools;
